<div class="wrapper"><angular-telegram-login-widget (login)="dialogRef.close($event)" [botName]="botName"></angular-telegram-login-widget></div>